import '.bk{flex-shrink:0;}.ssr-plugin'
import '.bm{padding:1rem;}.ssr-plugin'
import '.a4{width:100%;}.ssr-plugin'
import '.bh{height:100%;}.ssr-plugin'
import '.aw{border:none;}.ssr-plugin'
import '.ax{background-color:transparent;}.ssr-plugin'
import '.eb{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.af{align-items:stretch;}.ssr-plugin'
import '.di{position:sticky;}.ssr-plugin'
import '.ec{top:4rem;}.ssr-plugin'
import '.ed{z-index:7;}.ssr-plugin'
import '.a7{background-color:var(--palette-white);}.ssr-plugin'
import '.ee{padding-bottom:1rem;}.ssr-plugin'
import '.o{margin-bottom:1rem;}.ssr-plugin'
import '.ef{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.y{position:fixed;}.ssr-plugin'
import '.cb{top:0;}.ssr-plugin'
import '.bf{left:0px;}.ssr-plugin'
import '.bg{right:0px;}.ssr-plugin'
import '.eg{bottom:0px;}.ssr-plugin'
import '.eh{z-index:9999;}.ssr-plugin'
import '.ei{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.dg{justify-content:flex-end;}.ssr-plugin'
import '.bo{flex:1;}.ssr-plugin'
import '.b1{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bk bm a4 bh aw ax eb"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e af"
    >
      <div className="di ec ed a7 ee o ef d"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="y cb bf bg eg eh a7 ei d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bm d dg ef"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bo b1">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
